import React from 'react'
import { connect } from 'react-redux'
import { getListItems, changeListItem, nullDate } from 'tyan/public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from 'tyan/public/utility/formValues'
class AddInstrumentInfo extends React.Component {
    state = {
        id: this.props.id || 0,
        assetAccInfoID: this.props.assetAccInfoID || 0,
        fatherID: this.props.fatherID || 0,
        readOnly: this.props.readOnly || false,
    }

    componentDidMount = () => {
        this.handlerInitValue(this.props.id || 0)
    }

    handlerInitValue = (id) => {
        const { fatherID } = this.state
        Tyan.doPostEvent({
            event: 'GetInstrumentIntel',
            data: { id, fatherID },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas, fatherID}) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerSave = () => {
        const { onSave, onClose } = this.props
        const { id, changedValues基本信息, fatherID, assetAccInfoID } = this.state
        Tyan.doPostEvent({
            event: 'SaveInstrumentIntel',
            data: { id, changedValues基本信息, fatherID,assetAccInfoID},
            onEnd: ({id, errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }
 
    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        return  getFormValue(this, '基本信息', '设备编号') && getFormValue(this, '基本信息', '设备名称')
            && getFormValue(this, '基本信息', '设备型号') && getFormValue(this, '基本信息', 'fatherID') > 0
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteInstrumentIntel',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    fieldset基本信息 = () => {
        const { optionsParas: { obj设备分类 } } = this.state
        const { list: optionsList } = Tyan.utility.getListFromValues('设备分类', null, obj设备分类, {})
        const 状态 = getFormValue(this, '基本信息', '状态')
        const { optionsParas } = this.state
        const { readOnly } = this.props
        const s = { margin: '5px 15px 5px 15px', minWidth: 150, flex: 1 }
        var _fieldset = [
            { _text: '设备编号', minWidth: '45%', required:true },
            { _text: '设备名称', minWidth: '45%',  required:true },
            { _text: '设备型号', minWidth: '45%',  required:true },
            {
                _treeselect: '设备分类', name: 'fatherID', required: true, displayField: '分类名称', options: optionsList,
                leafOnly: false, displayFull: '/', displayName: 'fullName', fullNameField: 'fullName', rootText: '全部',
            },
            { _select: '设备类型', minWidth: '45%' },
            { _select: '计量类型', minWidth: '45%' },
            { _select: '管理员', minWidth: '45%' },
            { _select: '设备状态', minWidth: '45%', },
            { _int: '检定校准周期', minWidth: '45%', textAlign: 'left',},
            { _select: '检定标准周期单位', minWidth: '45%', },
            { _date: '检定校准日期', minWidth: '45%', },
            { _date: '下次检定/校准时间', name: '下次检定校准日期', minWidth: '45%', },
            { _int: '期间核查周期', minWidth: '45%', textAlign: 'left', },
            { _select: '期间核查周期单位', minWidth: '45%', },
            { _date: '期间核查日期', minWidth: '45%', },
            { _date: '下次期间核查时间', minWidth: '45%', },
            { _int: '维修保养周期', minWidth: '45%', textAlign: 'left', },
            { _select: '维修保养周期单位', minWidth: '45%', },
            { _date: '维修保养日期', minWidth: '45%', },
            { _date: '下次维修保养时间', minWidth: '45%', },
            { _select: '主检小组', minWidth: '45%', },
            { _files: '附件', minWidth: '90%' },
        ]

        return _fieldset
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly  }= this.props
        const { initValues基本信息, changedValues基本信息,id } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        const { 状态, 提交时间 } = initValues基本信息
        return <Body data={this} maxWidth="1200"
        controls={[
            { _button: '保存', icon: 'save', handler: () => this.handlerSave(), disabled: !(this.canSave() && this.bChanged()), },
            { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt:() => id > 0 },
            { _button: '关闭', icon: 'close', handler: this.handlerClose },
            
        ]}
            fieldsets={
                [
                    { title: '基本信息', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default connect()(AddInstrumentInfo)